module.exports = __webpack_public_path__ + "static/media/transactions-min-min.9dda76d1.png";